// extracted by mini-css-extract-plugin
export default {"textSecondary":"#616161","page":"Simple_page__EiMwM","logo":"Simple_logo__iKOXJ","pageDemo":"Simple_pageDemo__x4Ry-","relativeToDemo":"Simple_relativeToDemo__2KWNh"};